import * as React from "react";

const ShapeIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={24} width={24} {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M3 3h18v18H3z" />
  </svg>
);

export default ShapeIcon;
